import ContentBox from "../ContentBox";
import LoadingComponent from "../LoadingComponent";
import React from 'react';

interface LoadingWrapperProps {
    loading: boolean;
    title?: string;
    description: string;
    children: React.ReactNode;
    contentBoxProps?: {
        borderCustom?: string;
        actions?: React.ReactNode;
        [key: string]: any; // Suporte para outras propriedades dinâmicas
    };
}

const LoadingWrapper: React.FC<LoadingWrapperProps> = ({
    loading,
    title,
    description,
    children,
    contentBoxProps
}) => {
    return (
        <>
            {loading ? (
                <ContentBox
                    className="mb-4 p-6"
                    title={title}
                    description={description}
                    {...contentBoxProps}
                >
                    <LoadingComponent />
                </ContentBox>
            ) : (
                children
            )}
        </>
    );
};


export default LoadingWrapper;